import { useEffect, useState } from "react";
import "./App.css";
import {
  getFirestore,
  collection,
  getCountFromServer,
  getDocs,
} from "firebase/firestore";

import {  doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { ref } from "firebase/storage";

export const LeaderBoard = ({activeToken}) => {


  const db = getFirestore();
  const [refCount, setRefCount] = useState(3);
  const [refLoading, setRefLoading] = useState(false);
  const [referrers, setReferrers] = useState([]);


  async function getTopReferrers(limit, token) {

    console.log('getting referrers',token);
    setRefLoading(true);
  
    const leaderboardDocRef = doc(db, "telegram_leaderboard", "latest");
    const now = Date.now();
    const eightHoursInMillis = 8 * 60 * 60 * 1000;
  
    // 1. Check if cached data is fresh
    const leaderboardSnapshot = await getDoc(leaderboardDocRef);
    if (leaderboardSnapshot.exists()) {
      const leaderboardData = leaderboardSnapshot.data();
      const lastUpdatedTimestamp = leaderboardData.timestamp?.toMillis() || 0;
      if (now - lastUpdatedTimestamp < eightHoursInMillis) {
        setReferrers(leaderboardData.referrers);
        setRefLoading(false);
        return leaderboardData.referrers;
      }
    }
  
    // 2. Get Firebase Users
    const usersRef = collection(db, "telegram_users");
    const querySnapshot = await getDocs(usersRef);
  
    let referrerCounts = {};
    let userDetails = {};
    let users = [];
  
    querySnapshot.forEach((doc) => {
      let data = doc.data();
      users.push(data);
      if (data.refCode) {
        if (!referrerCounts[data.refCode]) {
          referrerCounts[data.refCode] = 0;
          userDetails[data.refCode] = {
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            imageUrl: data.imageUrl || "",
          };
        }
      }
    });
  
    users.forEach((user) => {
      if (user.parentUser && referrerCounts[user.parentUser] !== undefined) {
        referrerCounts[user.parentUser]++;
      }
    });
  
    let firebaseReferrers = Object.entries(referrerCounts)
      .sort((a, b) => b[1] - a[1])
      .map(([refCode, count]) => ({
        refCode,
        count,
        ...userDetails[refCode],
      }));
  
    // 3. Get External Leaderboard (only if token is available)
    console.log('will check for api now');
    let apiReferrers = [];
    if (token && token !== "") {
      console.log('getting referrers from api');
      
        const response = await fetch("https://api.emorya.com/leaderboard", {
          headers: {
            Authorization: "Token " + token,
          },
        });
        apiReferrers = await response.json();
     
      
      
    }else{
      console.log('skipping referrers from api',activeToken);
    }
  
    // 4. Normalize API data to match Firebase structure
    const normalizedApiReferrers = apiReferrers.map((item) => ({
      firstName: item.firstName,
      lastName: item.lastName,
      imageUrl: item.imageUrl,
      count: item.referredCount,
    }));
  
    // 5. Combine, deduplicate by full name, and sort
    const combined = [...firebaseReferrers, ...normalizedApiReferrers];
  
    const deduplicated = Object.values(
      combined.reduce((acc, item) => {
        const key = (item.firstName + " " + item.lastName).toLowerCase();
        if (!acc[key] || item.count > acc[key].count) {
          acc[key] = item;
        }
        return acc;
      }, {})
    );
  
    const top20 = deduplicated
      .filter((user) => user.firstName !== "Vijit")
      .sort((a, b) => b.count - a.count)
      .slice(0, limit);
  
    // 6. Cache and return
    await setDoc(leaderboardDocRef, {
      referrers: top20,
      timestamp: serverTimestamp(),
    });
  
    setReferrers(top20);
    setRefLoading(false);
  
    return top20;
  }
  
  
  useEffect(() => {
    console.log("activetoken",activeToken);
    getTopReferrers(20,activeToken);
  }, [activeToken]);
  return (
    <>
      <div className="hotHeading">
        <strong
          style={{
            fontSize: 14,
          }}
        >
          Leader Board Teams
        </strong>
      </div>
      {referrers.map((item, index) => {
        return (
          <div
            key={index}
            className="glowBox"
            style={{
              borderRadius: 5,
              marginTop: 2,
              position: "relative",
              display:((index < 3) ? '' : (refCount > 3) ? '' : 'none')
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 20,
                right: 10,
                fontFamily: "Bungee",
                color: "#eaac3b",
                fontSize: 13,
              }}
            >
              {index + 1}
            </div>
            <div className="memberLine">
              <div
                className="profileImageGreen"
                style={{
                  backgroundImage:
                    item.imageUrl &&
                    item.imageUrl != "" &&
                    item.imageUrl != null
                      ? `url(${item.imageUrl})`
                      : "",
                  height: 35,
                  width: 35,
                  borderRadius: "100%",
                }}
              ></div>
              <div
                style={{
                  marginLeft: 10,
                  fontSize: 13,
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                {item.firstName.trim()} {item.lastName.trim()}
                <br />
                <span
                  style={{
                    fontSize: 12,
                    fontFamily: "Quicksand",
                    fontWeight: "normal",
                  }}
                >
                  {item.count} Users
                </span>
              </div>
            </div>
          </div>
        );
      })}
      {refCount == 3 && referrers.length > 0 ? (
        <>
          <div
            className="glowBox"
            style={{
              marginTop: 5,
              padding: 10,
              fontSize: 10,
              fontWeight: "bold",
            }}
            onClick={() => {
              setRefCount(20);
            }}
          >
            {refLoading ? "Getting List.." : "View More"}
          </div>
        </>
      ) : null}
      <br />
    </>
  );
};
